import React from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import * as moment from "moment";
import JwtClient from "./JwtClient";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Alert from "./Alert";

class Address {
    constructor(zip, city, state, streetAddress) {
        this.zip = zip;
        this.city = city;
        this.state = state;
        this.address = streetAddress;
    }
}

function getAirportAddress(airportCode) {
    if (airportCode === 'JFK') {
        return new Address('11430', 'Queens, New York', 'NY', 'Queens');
    }
    if (airportCode === 'LAX') {
        return new Address('90045', 'Los Angeles', 'CA', '1 World Way');
    }
    if (airportCode === 'ORD') {
        return new Address('60666', 'Chicago', 'IL', '10000 W O\'Hare Av')
    }
}

function getCustomsAddress(airportCode) {
    if (airportCode === 'JFK') {
        return new Address('11430', 'Jamaica, New York', 'NY', 'Jamaica');
    }
    if (airportCode === 'LAX') {
        return new Address('90045', 'Los Angeles', 'CA', '11099 S La Cienega Blvd')
    }
    if (airportCode === 'ORD') {
        return new Address('60666', 'Chicago', 'IL', '10000 W O\'Hare Av')
    }
}

export default class ManifestEventForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alert: '',
            isSubmitting: false,
            values: {
                description: '',
                zip: '',
                city: '',
                state: '',
                address: '',
                event_date: '',
            },
            errors: {
                zip: '',
                city: '',
                state: '',
                event_date: '',
            },
        };
    }

    render() {
        if (!!this.state.alert) {
            return <Alert>{this.state.alert}</Alert>
        }

        const {
            values,
            isSubmitting,
            errors,
        } = this.state;

        return (
            <div>
                <hr/>
                <Form onSubmit={this.handleSubmit}>

                    <Form.Row>
                        <Col md>
                            <Form.Group>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>Event</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        as="select"
                                        type="text"
                                        name="description"
                                        value={values.description}
                                        onChange={this.handleChangeDescription}
                                        isInvalid={!!errors.description}
                                    >
                                        <option>---</option>
                                        {
                                            this.props.descriptions.map(i => (<option key={i}>{i}</option>))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.description}
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Form.Group>
                        </Col>

                        <Col md>
                            <Form.Group>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>Date (NY)</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        type="text"
                                        name="event_date"
                                        value={values.event_date}
                                        onChange={this.handleChange}
                                        isInvalid={!!errors.event_date}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.event_date}</Form.Control.Feedback>
                                </InputGroup>
                                <Form.Text className="text-muted">
                                    Format: YYYY-MM-DD HH:mm
                                </Form.Text>
                            </Form.Group>
                        </Col>
                    </Form.Row>

                    <Form.Row>
                        <Col md>
                            <Form.Group>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>Zip</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        type="text"
                                        name="zip"
                                        value={values.zip}
                                        onChange={this.handleChange}
                                        isInvalid={!!errors.zip}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.zip}</Form.Control.Feedback>
                                </InputGroup>
                                <Form.Text className="text-muted">
                                    Example: 12345 or 12345-1234
                                </Form.Text>
                            </Form.Group>
                        </Col>

                        <Col md>
                            <Form.Group>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>State</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        type="text"
                                        name="state"
                                        value={values.state}
                                        onChange={this.handleChange}
                                        isInvalid={!!errors.state}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.state}</Form.Control.Feedback>
                                </InputGroup>
                                <Form.Text className="text-muted">
                                    Example: IL
                                </Form.Text>
                            </Form.Group>
                        </Col>

                        <Col md>
                            <Form.Group>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>City</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        type="text"
                                        name="city"
                                        value={values.city}
                                        onChange={this.handleChange}
                                        isInvalid={!!errors.city}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.city}</Form.Control.Feedback>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Form.Row>

                    <Row>
                        <Col className="text-left">
                            <Button href="/" type="button" disabled={isSubmitting} className="btn-danger">Back</Button>
                        </Col>

                        <Col className="text-right">
                            <Button type="submit" disabled={isSubmitting} className="btn-success">Add Event</Button>
                        </Col>
                    </Row>

                </Form>
            </div>
        )
    }

    isValidForm = () => {
        const {
            values,
        } = this.state;
        let valid = true;

        if (values.description.length === 0) {
            this.setErrors({description: 'required'});
            valid = false;
        }

        if (values.state.length === 0) {
            this.setErrors({state: 'required'});
            valid = false;
        } else if (values.state.length !== 2) {
            this.setErrors({state: 'must be 2 letters'});
            valid = false;
        }

        const zipReg = /[0-9]{5}|[0-9]{5}-[0-9]{4}/;
        if (values.zip.length === 0) {
            this.setErrors({zip: 'required'});
            valid = false;
        } else if (!zipReg.test(values.zip)) {
            this.setErrors({zip: 'invalid format'});
            valid = false;
        }

        if (values.city.length === 0) {
            this.setErrors({city: 'required'});
            valid = false;
        }

        if (values.event_date.length === 0) {
            this.setErrors({event_date: 'required'});
            valid = false;
        } else if (!moment(values.event_date, this.eventDateFormat, true).isValid()) {
            this.setErrors({event_date: 'invalid format'});
            valid = false;
        }

        return valid;
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.setSubmitting(true);
        if (this.isValidForm()) {
            this.postEvent();
        } else {
            this.setState({alert: ''})
        }
        this.setSubmitting(false);
        this.clearValues();
    };

    postEvent = () => {
        const event = this.state.values;

        JwtClient.post(`/api/v1/admin/manifests/${this.props.manifestId}/events`, {
            zip: event.zip,
            state: event.state,
            city: event.city,
            address: event.address,
            description: event.description,
            event_date: moment.tz(event.event_date, 'America/New_York').utc().format(),
        })
            .then(response => {
                if (response.status === 201) {
                    this.setState({alert: 'Successfully added'});
                    this.props.addEvent(event);
                }
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        this.setState({alert: 'Unauthorized'})
                    }
                    this.setState({alert: 'Error on posting manifest event values, status: ' + error.response.status + ' Data: ' + JSON.stringify(error.response.data)});
                } else {
                    this.setState({alert: JSON.stringify(error)});
                }
            })
    };

    handleChange = (e) => {
        this.setErrors({[e.target.name]: ''});
        this.setValues({[e.target.name]: e.target.value});
    };

    handleChangeDescription = (e) => {
        const d = e.target.value;
        let a;
        if (d.includes('airport')) {
            a = getAirportAddress(this.props.destinationAirport);
        }
        if (d.includes('customs')) {
            a = getCustomsAddress(this.props.destinationAirport);
        }

        if (!!a) {
            this.setValues({
                zip: a.zip,
                city: a.city,
                state: a.state,
                address: a.address,
                event_date: moment.tz('America/New_York').format('YYYY-MM-DD HH:mm'),
                description: d,
            });
        } else {
            this.setValues({
                event_date: moment.tz('America/New_York').format('YYYY-MM-DD HH:mm'),
                description: d,
            });
        }
    };

    setValues = (values) => {
        this.setState((prevState) => ({values: {...prevState.values, ...values}}));
    };

    clearValues = () => {
        this.setState({values: {description: '', zip: '', city: '', address: '', state: '', event_date: ''}});
    };

    setSubmitting = (isSubmitting) => {
        this.setState({isSubmitting: isSubmitting});
    };

    setErrors = (errors) => {
        this.setState((prevState) => ({errors: {...prevState.errors, ...errors}}));
    };
}